export default __webpack_public_path__ + "static/media/MushieLogo.a11b7914.png";